
export const RepoCard = ({ repo }) =>
  <div className="p-6 bg-black/20 backdrop-blur-xl border border-white/10 rounded-xl hover:bg-black/30 transition-colors">
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-3">
        <i className="fab fa-git-alt text-red-400"></i>
        <span className="font-mono text-white">{repo.owner}/{repo.name}</span>
      </div>
      <button
        className="text-zinc-400 hover:text-red-400 px-2 py-1 rounded"
        onClick={() => navigator.clipboard.writeText(`git clone ${repo.url}`)}
        title="Copy clone command"
      >
        <i className="fas fa-copy"></i>
      </button>
    </div>
    <code className="text-xs text-zinc-300 bg-black/50 px-3 py-2 rounded block font-mono break-all">
      {repo.url}
    </code>
  </div>
